import { ReactNode, FunctionComponent, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import tw, { styled } from 'twin.macro';

import { DefaultNavigationBar, Footer, NavigationVariantType } from '@restworld/ui-ds';
import { getAssetSrc } from '@restworld/utils-common';
import { useAuth } from '@restworld/feature-authentication';

export const LayoutWrapperOld: FunctionComponent<ILayoutWrapperProps> = ({
  children,
  title,
  hasFooter,
  hasNavbar,
  navbarVariant,
  showSearchBarInNavbar,
  isNavbarOffScreen,
}) => {
  const authContext = useAuth();
  const { isFallback } = useRouter();
  const [isNavOverlay, navOverlayToggler] = useState(false);

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="shortcut icon" href={getAssetSrc('/utils-assets/favicons/favicon.ico')} />
        <link rel="stylesheet" href="https://unpkg.com/flowbite@1.4.5/dist/flowbite.min.css" />
        <title>{isFallback ? 'loading...' : title}</title>
      </Head>

      {hasNavbar ? (
        <NavigationContainer isOffScreen={isNavbarOffScreen}>
          <DefaultNavigationBar
            variant={navbarVariant}
            authProps={{
              ...{
                onLogout() {
                  authContext?.logout();
                },
                onStartSignup() {
                  /**To be implemented */
                },
                onStartLogin() {
                  /**To be implemented */
                },
              },
            }}
            showSearchBarInNavbar={showSearchBarInNavbar}
            isNavOverlay={isNavOverlay}
            navOverlayToggler={navOverlayToggler}
          />
        </NavigationContainer>
      ) : null}
      {children}
      {hasFooter ? <Footer /> : null}
    </>
  );
};

export interface ILayoutWrapperProps {
  title: string;
  children: ReactNode;
  hasFooter?: boolean;
  hasNavbar?: boolean;
  navbarVariant?: NavigationVariantType;
  showSearchBarInNavbar?: boolean;
  isNavbarOffScreen?: boolean;
  showLegacyLayout?: boolean;
  hideNavigation?: boolean;
}

const NavigationContainer = styled.div<{ isOffScreen?: boolean }>(({ isOffScreen }) => [
  tw`absolute top-0 w-full left-0 z-50 transition-all duration-500`,
  isOffScreen ? tw`top-[-1000px]` : tw``,
]);
